import {roomRecordApi} from "@/core/api/room.record.api";

export default {
    checkReadyToRoomRecord: ({ dispatch, commit, getters, rootGetters }) => {
        try {
            if (!rootGetters["user/hasEmceeRole"]()) {
                throw Promise.reject('permission-denied');
            }
            
            return roomRecordApi.checkInstallChromeExtension();
        } catch (e) {
            e.catch(reason=> {
                commit('RECORD_ERROR', reason);
            })
            return e;
        }
    },
    startRoomRecord: async ({dispatch, commit, getters, rootGetters}) => {
        commit('CHANGE_CLIENT_RECORD_STATE', 'start');
        await dispatch('changeRoomRecordState', 'start');
    },
    pauseRoomRecord: async ({dispatch, commit, getters, rootGetters}) => {
        await dispatch('changeRoomRecordState', 'pause');
        commit('CHANGE_CLIENT_RECORD_STATE', 'pause');
    },
    stopRoomRecord: ({dispatch, commit, getters, rootGetters}) => {
        dispatch('changeRoomRecordState', 'stop');
    },
    changeRoomRecordState: async ({dispatch, commit, getters, rootGetters}, data) => {
        try {
            await roomRecordApi.changeRoomRecordState(data);
        } catch(e) {
            let message = e instanceof Error ? e.message : e;
            commit('RECORD_ERROR', message);
            throw e;
        }
    },
    // updateRecordFileList: async({dispatch, commit, getters, rootGetters}) => {
    //     let recFileList = await roomRecordApi.getRecordFileList();
    //     commit('updateRecordFileList', recFileList);
    // },
    getRecordFileUrl: async({dispatch, commit, getters, rootGetters}, data) => {
        let {recordId} = data;
        try {
            return await roomRecordApi.getRecordFileUrl(recordId);
        } catch (e) {
            dispatch('common/setAlert', {
                text: '녹화 서버를 찾을 수 없습니다\n 잠시 후 다시 시도해주세요',
                onlyOk: true
            }, { root: true });
            throw e;
        }
    },
    deleteRecordFile: async({dispatch, commit, getters, rootGetters}, data) => {
        const { recordFile: { recordId } } = data;
        await roomRecordApi.deleteRecordFile(recordId);
        commit('RECORD_FILE_REMOVE', { recordId });
        commit('REMOVE_RECORD_FILE_INSTANCE', { recordId });
    },

}
